import axios from 'axios';
import apiConfig from '../config/api.config';

const contentClient = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
  headers: apiConfig.headers
});

const contentService = {
  /**
   * KVKK metnini API'den çeker
   * @returns {Promise<string|null>} Decoded HTML string veya null
   */
  async getKvkkText() {
    const response = await contentClient.post('/v1/api/GenericObjectItemDetail', {
      hostName: apiConfig.hostName,
      url: 'kvkk'
    });

    const rawBody = response.data?.data?.data?.Body;
    if (!rawBody) return null;

    // Çift-encode: önce outer HTML'i parse et, textContent ile inner HTML'i al
    const outer = new DOMParser().parseFromString(rawBody, 'text/html');
    const decoded = outer.body.textContent || '';

    // Decoded HTML içinden span'ı bul
    const inner = new DOMParser().parseFromString(decoded, 'text/html');
    const span = inner.querySelector('span');
    return span ? span.innerHTML : inner.body.textContent;
  },

  /**
   * KVKK PDF URL'ini API'den çeker
   * @returns {Promise<string|null>} Tam PDF URL'i
   */
  async getKvkkPdfUrl() {
    const response = await contentClient.post('/v1/api/GenericObjectItemDetail', {
      hostName: apiConfig.hostName,
      url: 'kvkk-aydinlatma-metni'
    });
    const body = response.data?.data?.data?.Body;
    if (!body) return null;
    return `${window.location.origin}/${body}`;
  },

  /**
   * Verilen URL'e ait sayfa içeriğini ham HTML olarak çeker
   * @param {string} url - CMS url alanı (örn: 'kvkk-aydinlatma-metni')
   * @returns {Promise<{title:string, body:string}|null>}
   */
  async getPageContent(url) {
    const response = await contentClient.post('/v1/api/GenericObjectItemDetail', {
      hostName: apiConfig.hostName,
      url
    });

    const data = response.data?.data;
    if (!data) return null;

    const rawBody = data.data?.Body || '';

    // Body çift-encode edilmiş: her <div> içindeki &lt;&gt; entity'lerini
    // DOMParser ile text olarak okuyup gerçek HTML'e dönüştür
    let body = rawBody;
    if (rawBody) {
      const doc = new DOMParser().parseFromString(rawBody, 'text/html');
      body = doc.body.textContent || rawBody;
    }

    return {
      title: data.title || '',
      body
    };
  },

  /**
   * Genel site ayarlarını çeker (EBulletinActive, EBulletinRecaptchaActive, vb.)
   * @returns {Promise<object|null>} data.data objesi veya null
   */
  async getSiteSettings() {
    const response = await contentClient.post('/v1/api/GenericObjectItemDetail', {
      hostName: apiConfig.hostName,
      url: 'genel-ayarlar'
    });
    return response.data?.data?.data || null;
  }
};

export default contentService;
